import React from 'react';

import { ReactModalService } from '~commonInfra/dialogs/ReactModalService';

import { FlowAnalyticsExtensions } from '../resources/FlowAnalyticsExtensions';
import { FlowAnalyticsExtensionConnection } from '../serverApi/types/FlowAnalyticsExtensionConnection';
import { FlowAnalyticsExtensionDialog } from './FlowAnalyticsExtensionDialog';

export function openFlowAnalyticsExtensionDialog(connection: FlowAnalyticsExtensionConnection, flowLuid: string): Promise<void> {
  if (!connection.canUpdate || !flowLuid) {
    return Promise.resolve();
  }
  return ReactModalService.openCustom<void>(({ close }) => (
    <FlowAnalyticsExtensionDialog
      connection={connection}
      loadConnections={() => FlowAnalyticsExtensions.getOptions(flowLuid)}
      applyConnection={connectionLuid => FlowAnalyticsExtensions.updateConnection(flowLuid, connectionLuid)}
      onClose={() => close()}
    />
  )).result;
}
